<div *ngIf="data"  class="detail-content">
    <mat-grid-list cols="2" rowHeight="40px">
        <div>
            <mat-form-field class="full-width">
                <mat-label>Language Id</mat-label>
                <mat-select [(ngModel)]="data.langId" [compareWith]="customCompare">
                  <mat-option>None</mat-option>
                  <mat-option value=0>0</mat-option>
                  <mat-option value=1>1</mat-option>
                  <mat-option value=2>2</mat-option>
                  <mat-option value=3>3</mat-option>
                  <mat-option value=4>4</mat-option>
                  <mat-option value=5>5</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="half-width">
                <mat-label>Name Translations</mat-label>
                <input matInput [(ngModel)]="data.name">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="half-width">
                <mat-label>Last Name Translations</mat-label>
                <input matInput [(ngModel)]="data.lastName">
            </mat-form-field>
        </div>

        <div>
            <mat-form-field class="half-width" appe>
                <mat-label>Age Translations</mat-label>
                <input matInput   [(ngModel)]="data.age">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="half-width">
                <mat-label>Country Translations</mat-label>
                <input matInput [(ngModel)]="data.country">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="half-width">
                <mat-label>Email Translations</mat-label>
                <input matInput [(ngModel)]="data.email">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="half-width">
                <mat-label>Source Translations</mat-label>
                <input matInput [(ngModel)]="data.source">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="half-width">
                <mat-label>Female Translations</mat-label>
                <input matInput [(ngModel)]="data.female">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="half-width">
                <mat-label>Male Translations</mat-label>
                <input matInput [(ngModel)]="data.male">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="half-width">
                <mat-label>Signature Header Translations</mat-label>
                <input matInput [(ngModel)]="data.signatureHeader">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="half-width">
                <mat-label>Signature Error Translations</mat-label>
                <input matInput [(ngModel)]="data.signatureError">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="full-width">
                <mat-label>Id Passport Translations</mat-label>
                <input matInput [(ngModel)]="data.idPassport">
            </mat-form-field>
        </div>
    </mat-grid-list>
</div>